const LOCAL = 'local';
const PROTO0 = 'proto0';
const STAGING = 'staging';
const PROD = 'prod';
const BRANCH = 'branch';

module.exports = {
  LOCAL,
  PROTO0,
  STAGING,
  PROD,
  BRANCH,
};
